import _slicedToArray from "/codebuild/output/src997666004/src/github.com/EverlyWell/www/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useRef, useEffect } from "react";
import { useDisableScroll } from "../../../shared/hooks";
import { Support, Account as AccountIcon } from "../../Icons";
import { topLevelLinks, AccountLinks as BackupAccountLinks } from "../links";
import { DesktopMenuItem } from "./DesktopMenuItem";
import { ShopDrawerContent } from "./DesktopMenuDrawers/shop";
import { LearnDrawerContent } from "./DesktopMenuDrawers/learn";
import { ForBusinessesDrawerContent } from "./DesktopMenuDrawers/for-business";
import * as S from "./styles";
export var Menu;
!function (e) {
  e[e.None = 0] = "None", e[e.Shop = 1] = "Shop", e[e.Learn = 2] = "Learn", e[e.ForBusiness = 3] = "ForBusiness", e[e.Account = 4] = "Account";
}(Menu || (Menu = {}));
export var DesktopMenu = function DesktopMenu(_ref) {
  var e = _ref.loggedIn,
      t = _ref.accountLinks,
      n = _ref.onMenuOpen,
      o = _ref.onMenuClose,
      a = _ref.onSubMenuOpen,
      u = _ref.onSubMenuClose;

  var l = useRef(),
      _useState = useState(Menu.None),
      _useState2 = _slicedToArray(_useState, 2),
      r = _useState2[0],
      c = _useState2[1],
      s = function s(e) {
    return function () {
      var t = r === e ? Menu.None : e;
      c(t);
    };
  },
      i = s(Menu.None),
      p = r === Menu.Shop,
      m = r === Menu.Learn,
      k = r === Menu.ForBusiness,
      L = r === Menu.Account;

  return useEffect(function () {
    r === Menu.None ? o && o() : n && n();
  }, [r]), useEffect(function () {
    var e = function e(_e) {
      var t;
      (null === (t = l.current) || void 0 === t ? void 0 : t.contains(_e.target)) || i();
    };

    return L ? document.addEventListener("mousedown", e) : document.removeEventListener("mousedown", e), function () {
      return document.removeEventListener("mousedown", e);
    };
  }, [L, i]), useDisableScroll(p || m || k), React.createElement(S.MenuWrapper, {
    "data-testid": "desktop-menu"
  }, React.createElement(S.MenuLeftHalf, null, React.createElement(DesktopMenuItem, {
    active: p,
    label: topLevelLinks.shop.label,
    menuSlug: Menu.Shop,
    onClickHandler: s(Menu.Shop),
    handleClose: i
  }, React.createElement(ShopDrawerContent, {
    active: p,
    onSubMenuOpen: a,
    onSubMenuClose: u
  })), React.createElement(DesktopMenuItem, {
    active: m,
    label: topLevelLinks.learn.label,
    menuSlug: Menu.Learn,
    onClickHandler: s(Menu.Learn),
    handleClose: i
  }, React.createElement(LearnDrawerContent, {
    active: m
  })), React.createElement(DesktopMenuItem, {
    active: k,
    label: topLevelLinks.business.label,
    menuSlug: Menu.ForBusiness,
    onClickHandler: s(Menu.ForBusiness),
    handleClose: i
  }, React.createElement(ForBusinessesDrawerContent, {
    active: k
  }))), React.createElement(S.MenuRightHalf, null, React.createElement(S.RegisterLink, {
    href: topLevelLinks.register.url
  }, topLevelLinks.register.label), React.createElement(S.MenuLink, {
    href: topLevelLinks.support.url,
    "aria-label": topLevelLinks.support.label
  }, React.createElement(Support, null)), e ? React.createElement(S.MenuButton, {
    "data-testid": "desktop-account-menu-button",
    ref: l,
    onClick: s(Menu.Account)
  }, React.createElement(AccountIcon, null), t ? React.createElement(React.Fragment, null, React.createElement(S.TextWrapper, null, t.label), React.createElement(S.AccountSubMenu, {
    "data-testid": "desktop-account-menu",
    active: L
  }, React.createElement(S.MenuLink, {
    href: t.results.url
  }, t.results.label), React.createElement(S.MenuLink, {
    href: t.settings.url
  }, t.settings.label), React.createElement(S.MenuLink, {
    href: t.logout.url
  }, t.logout.label))) : React.createElement(React.Fragment, null, React.createElement(S.TextWrapper, null, BackupAccountLinks.label), React.createElement(S.AccountSubMenu, {
    "data-testid": "desktop-account-menu",
    active: L
  }, React.createElement(S.MenuLink, {
    href: BackupAccountLinks.results.url
  }, BackupAccountLinks.results.label), React.createElement(S.MenuLink, {
    href: BackupAccountLinks.settings.url
  }, BackupAccountLinks.settings.label), React.createElement(S.MenuLink, {
    href: BackupAccountLinks.logout.url
  }, BackupAccountLinks.logout.label)))) : React.createElement(S.MenuLink, {
    "data-testid": "desktop-login-link",
    href: topLevelLinks.login.url
  }, React.createElement(AccountIcon, null), React.createElement(S.TextWrapper, null, topLevelLinks.login.label))));
};
export default DesktopMenu;